import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationApiService extends ApiService {
  constructor() {
    super();
  }

  public getConfiguration$(): Observable<ConfigurationDto> {
    return this.get('/configuration');
  }
}

export interface ConfigurationDto {
  playbookClauseMaxSizeInCharacters: number;
  keyQuestionMaxSizeInCharacters: number;
  addClauseInstructionsMaxSizeInCharacters: number;
  questionMaxSizeInCharacters: number;
  rewriteInstructionsMaxSizeInCharacters: number;
  contentToRewriteMaxSizeInCharacters: number;
}

export const apiConfigurationProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiConfiguration.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiConfiguration.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiConfiguration.scopes.write],
  },
  {
    httpMethod: 'DELETE',
    scopes: [...environment.protectedResources.apiConfiguration.scopes.write],
  },
];
